import '/components/estate-teaser/estate-teaser';
import '/components/estate-teaser/estate-teaser.scss';
